package com.shadowings.gero.domain.model

/**
 * Costanti di gioco centralizzate.
 * Aggiornare qui per cambiare le regole di bilanciamento.
 */
object GameConstants {
    /** Cuori con cui inizia / a cui si resetta il giocatore. */
    const val DEFAULT_HEARTS = 10

    /** Cuori guadagnati aprendo l'app in un giorno nuovo. */
    const val DAILY_BONUS_HEARTS = 5

    /** Cuori guadagnati guardando una pubblicità rewarded. */
    const val AD_REWARD_HEARTS = 5

    /** Quante domande consecutive corrette triggherano QuizComboFive. */
    const val COMBO_THRESHOLD = 5

    /** Quanti errori consecutivi triggherano QuizThreeErrors. */
    const val ERRORS_THRESHOLD = 3

    /** Quante domande vengono estratte per ogni quiz. */
    const val QUIZ_QUESTIONS_COUNT = 10

    /** Formula per calcolare il livello giocatore a partire dall'esperienza (XP). */
    fun getPlayerLevel(xp: Int): Int {
        if (xp <= 0) return 1
        val l = (1.0 + kotlin.math.sqrt(1.0 + xp.toDouble() / 1.25)) / 2.0
        return l.toInt()
    }

    /** Formula per calcolare l'esperienza richiesta per raggiungere un certo livello. */
    fun getXpRequiredForLevel(level: Int): Int {
        if (level <= 1) return 0
        return 5 * level * (level - 1)
    }
}
